import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import { productLinks } from 'settings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const buttons = {
  ios: 'app-store',
  android: 'google-play',
};

const StoreButtons = ({ title }) => (
  <React.Fragment>
    {title && <h3>{i18n.translate('homeScreen.storeButtons.getApp')}</h3>}
    <div className="storeButtons__container">
      {Object.keys(buttons).map((key) => (
        <a key={key} href={productLinks[key]} target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={['fab', buttons[key]]} />
        </a>
      ))}
    </div>
  </React.Fragment>
);

export default StoreButtons;

StoreButtons.propTypes = {
  title: PropTypes.bool,
};

StoreButtons.defaultProps = {
  title: false,
};
